import polyglotI18nProvider from "ra-i18n-polyglot";
import de from "./de";
import en from "./en";

export const i18nProvider = polyglotI18nProvider((langCode) => {
    if (langCode && langCode !== "de") return de;
    return en;
}, "de");
